<template>
  <div :class="(padding || border || color) ? getClasses() :''">
    <i v-show="icon" :class="icon" class="icon-header"></i>
    <span class="header-text">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "SCardHeader",
  props: {
    padding: { type: Boolean, default: false },
    title: { type: String, default: "freight mode" },
    icon: { type: String, default: "fas fa-trailer icon-header" },
    border: { type: Boolean, default: false },
    light: { type: Boolean, default: false },
  },
  methods: {
    getClasses() {
      let cssClass = " ";
      if (this.padding) {
        cssClass = cssClass + " padding";
      }
      if (this.border) {
        cssClass = cssClass + " border";
      }
      if (this.color) {
        cssClass = cssClass + " border__var";
      }
      return cssClass;
    },
  },
};
</script>

<style scoped>
.icon-header {
  font-size: 18px;
  padding-right: 16px;
}
.header-text {
  text-transform: uppercase;
    font-family: "Roboto !important";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000000;
}

.row {
  margin: 0px !important;
}
.header {
  width: 100%;
}
.padding {
  padding: 24px;
}
.col__left {
  float: left;
}
.col__right {
  float: left;
}
.card__header {
    font-family: "Roboto !important";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: black;
}
.border {
  border-bottom: 1px solid var(--very-light-pink);
}
</style>
